import script from "./PatientList.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatientList.vue?vue&type=script&setup=true&lang=ts"

import "./PatientList.vue?vue&type=style&index=0&id=19c784a3&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19c784a3"]])

export default __exports__